import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of, switchMap } from 'rxjs';

import * as DataAccessProfessionsActions from './data-access-professions.actions';

import * as DataAccessPostsActions from '../../posts/entity/data-access-posts.actions';

@Injectable()
export class DataAccessProfessionsEffects {
  loadPostProfessions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataAccessPostsActions.postLoadSucceeded),
      switchMap((action) =>
        of(
          DataAccessProfessionsActions.professionsLoadSucceeded({
            professions: action.post.professions ?? [],
          })
        )
      )
    )
  );

  constructor(private readonly actions$: Actions) {}
}
